export const KVMHeaderViews = {
  ADD_LXD_HOST: ["kvmForm", "addLXDHost"],
  ADD_VIRSH_HOST: ["kvmForm", "addVirshHost"],
  COMPOSE_VM: ["kvmForm", "composeVM"],
  DELETE_KVM: ["kvmForm", "deleteKVM"],
  REFRESH_KVM: ["kvmForm", "refreshKVM"],
} as const;
